<template>
	<div class="c-brands-slug">
		<PageHeader
			v-if="brand"
			byline="Brand"
			:breadcrumbs="breadcrumbs"
			:showMenu="true"
		>
			<template v-slot:title> {{ brand.name }} </template>

			<template v-slot:menu>
				<router-link
					:class="[{ active: fullCleanPath === '/' }]"
					:to="`/brands/${slug}`"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 24 24"
						fill="none"
					>
						<path
							d="M9 6C8.44772 6 8 6.44772 8 7C8 7.55228 8.44772 8 9 8V6ZM15 8C15.5523 8 16 7.55228 16 7C16 6.44772 15.5523 6 15 6V8ZM9 10C8.44772 10 8 10.4477 8 11C8 11.5523 8.44772 12 9 12V10ZM12 12C12.5523 12 13 11.5523 13 11C13 10.4477 12.5523 10 12 10V12ZM7 4H17V2H7V4ZM18 5V19H20V5H18ZM17 20H7V22H17V20ZM6 19V5H4V19H6ZM7 20C6.44771 20 6 19.5523 6 19H4C4 20.6569 5.34315 22 7 22V20ZM18 19C18 19.5523 17.5523 20 17 20V22C18.6569 22 20 20.6569 20 19H18ZM17 4C17.5523 4 18 4.44772 18 5H20C20 3.34315 18.6569 2 17 2V4ZM7 2C5.34315 2 4 3.34315 4 5H6C6 4.44772 6.44772 4 7 4V2ZM18 12V15H20V12H18ZM17 16H7V18H17V16ZM7 22H10V20H7V22ZM7 16C5.34315 16 4 17.3431 4 19H6C6 18.4477 6.44772 18 7 18V16ZM18 15C18 15.5523 17.5523 16 17 16V18C18.6569 18 20 16.6569 20 15H18ZM9 8H15V6H9V8ZM9 12H12V10H9V12Z"
							fill="currentColor"
						/>
					</svg>
					<span>Insights</span>
				</router-link>
				<router-link
					:class="[{ active: fullCleanPath === '/ads' }]"
					:to="`/brands/${slug}/ads`"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 24 24"
						fill="none"
					>
						<path
							d="M18 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4Z"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M12 9.5L16 9.5"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M12 14.5L16 14.5"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<circle cx="8.25" cy="9.5" r="1.25" fill="currentColor" />
						<circle cx="8.25" cy="14.5" r="1.25" fill="currentColor" />
					</svg>
					<span>Ads</span>
				</router-link>
			</template>
		</PageHeader>
		<div class="c-brands-slug__inner" v-if="brand">
			<Insight v-if="fullCleanPath === '/'" :brand="brand"></Insight>
			<router-view></router-view>
		</div>
		<div class="c-brands-slug__empty-state" v-if="!brand && !error">
			<span class="c-spinner"></span>
		</div>
		<div class="c-brands-slug__error" v-if="error">
			<article>
				<h3>404 brand not found</h3>
				<p>
					<router-link to="/brands"> Go back </router-link>
				</p>
			</article>
		</div>
	</div>
</template>

<script>
import PageHeader from '@swipekit/components/utils/page-header';
import Insight from './insight';
import api from '@swipekit/lib/api';

export default {
	components: {
		PageHeader,
		Insight,
	},

	data: function () {
		return {
			brand: null,
			error: false,
		};
	},

	computed: {
		breadcrumbs: function () {
			return [
				{
					name: 'Back',
					url: '/brands',
				},
				{
					name: `Brand data`,
				},
			];
		},
		slug: function () {
			if (this.$route.params) {
				return this.$route.params.slug;
			} else {
				return '';
			}
		},
		fullCleanPath: function () {
			let path = this.$route.fullPath;

			if (this.$route.name === 'BrandsSlug') {
				return '/';
			}

			if (this.$route.name === 'Ads') {
				return '/ads';
			}

			if (this.$route.name === 'LandingPages') {
				return '/landing-pages';
			}

			path = path.split('?')[0];

			return path;
		},
	},

	methods: {
		async loadData() {
			let slug = this.$route.params.slug;
			let brand = await api.brands.getOne(slug);

			if (!brand) {
				this.error = true;
				return;
			}

			brand.tracker = brand.trackers[0];

			delete brand.trackers;

			this.brand = brand;

			return brand;
		},
	},

	mounted: function () {
		this.loadData();
	},
};
</script>

<style lang="scss">
.c-brands-slug {
	&__inner {
		position: relative;
	}

	&__empty-state {
		padding: var(--spacer);
		padding-top: calc(var(--spacer-lg) * 2);
		display: flex;
		align-items: center;
		justify-content: center;

		.c-spinner {
			width: 48px;
			height: 48px;
			border-width: 3px;
			border-color: transparent;
			border-bottom-color: var(--color-primary);
		}
	}

	&__error {
		display: flex;
		align-items: center;
		justify-content: center;

		padding: var(--spacer);
		padding-top: calc(var(--spacer-lg) * 2);
	}
}
</style>
